import { HeadersService } from './headers.service';
import { PeersService } from './peers.service';
import { Injectable } from '@angular/core';
import { OrganisationService } from './organisation.service';
import { UserData } from '../models/identity/user-data';
import { ServiceMessageService } from './service-message.service';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { forkJoin, Observable, of, switchMap, zip, catchError } from 'rxjs';
import { UserpilotService } from './userpilot.service';
import { SecurityService } from './security.service';

@Injectable()
export class SetupService {
    public isSetup = false;
    constructor(private securityService: SecurityService, private headersService: HeadersService,
        private peersService: PeersService, private organisationService: OrganisationService,
        private appInsightsService: ApplicationInsights, private serviceMessageService: ServiceMessageService,
        private userPilotService: UserpilotService) {
    }

    ensureAppIsSetUp(): Observable<boolean> {
        if (!this.isSetup) {

            return this.securityService.getUserData().pipe(
                switchMap((userData: UserData) => {
                    
                    if (userData.sub) {
                        this.appInsightsService.clearAuthenticatedUserContext();
                        this.appInsightsService.setAuthenticatedUserContext(userData.sub, userData.preferredUsername, true);

                        this.userPilotService.identify(userData);
                    }

                    const zip$ = forkJoin([
                        this.organisationService.getUsersOrganisations(userData),
                        this.peersService.fetchOrganisations(),
                        this.peersService.fetchDynamicPeerGroupFilters(),
                        this.peersService.fetchDefaultPeers(),
                        this.serviceMessageService.fetchServiceMessage()
                    ]);

                    return zip$.pipe(
                        switchMap((res) => {
                            this.isSetup = true;
                            return of(true);
                        })
                    );
                })
            );
        }

        return of(true);
    }
}
